export default __webpack_public_path__ + "static/media/sf-ledger-deposit.9cbb4653.png";